import React, { FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

interface UpdateNowDialogProps {
  open: boolean;
  // onClose: () => void;
  onUpdateNow: () => void;
  onUpdateLater: () => void;
  title: string;
  updateNow: string;
  updateLater: string;

}

const UpdateNowDialog: FC<UpdateNowDialogProps> = ({onUpdateNow, onUpdateLater, open, title, updateNow, updateLater }) => {

  return (
    <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>{title}</DialogTitle>
        <DialogContent>
          <Button color="primary" variant="contained" fullWidth onClick={onUpdateNow}>
            {updateNow}
          </Button>  
        </DialogContent>
        <DialogContent>
          <Button color="primary" variant="contained" fullWidth onClick={onUpdateLater}>
            {updateLater}
          </Button>  
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
  );
}

export default UpdateNowDialog;